import React from "react";
import { Formik, Form } from "formik";
import * as Components from "components";
import { toast } from "react-toastify";
import { useUserStore } from "(store)/useUserStore";
import { FormButton, SwitchField } from "components/formfields";
import { SecuritySettingsSchema } from "utils/Validation";
import { SettingSecurityForm } from "components/forms";
import {
  changePassword,
  getProfile,
  updateProfile,
} from "services/admin.service";

const SecuritySettings = () => {
  const { userInfo, setUser } = useUserStore();

  const initialValues = {
    is2FA: userInfo?.is2FA || false,
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  // update zustand
  const fetchProfile = async () => {
    getProfile()
      .then((res) => {
        if (res?.status === 200) {
          const { data } = res.data;
          if (data) {
            setUser(data);
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleToggle2FA = async (value) => {
    const payload = { data: JSON.stringify({ is2FA: value }) };
    try {
      await updateProfile(payload);
      fetchProfile();
    } catch (error) {
      toast.error(error?.error || "Failed to update Two-Step Verification!");
    }
  };

  const handleSubmitPasswordChange = async (
    values,
    { setSubmitting, setFieldValue }
  ) => {
    setSubmitting(true);
    const payload = {
      password: values.currentPassword,
      newPassword: values.newPassword,
    };

    try {
      await changePassword(payload);
      toast.success("Password changed successfully!");
      setFieldValue("currentPassword", "");
      setFieldValue("newPassword", "");
      setFieldValue("confirmPassword", "");
    } catch (error) {
      toast.error(error?.error || "Password change failed!");
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <div className="min-h-screen p-5 border dark:border-gray-800 dark:bg-[#181818] my-5 mx-5 2xl:mx-14 rounded-lg shadow-lg">
      <Formik
        initialValues={initialValues}
        validationSchema={SecuritySettingsSchema}
        onSubmit={handleSubmitPasswordChange}
      >
        {({ isSubmitting, isValid, errors, values, setFieldValue }) => {
          return (
            <Form className="">
              <div className="flex flex-col pt-4">
                <div className="pb-4 border-b dark:border-gray-800">
                  <h2 className="text-xl text-secondary dark:text-alpha">
                    Two Step Verification
                  </h2>
                  <p className="text-[1em] text-[#737373] dark:text-gray-300">
                    Toggle the switch to enhance your account security by
                    requiring a second verification step when signing in.
                  </p>
                </div>
                <div className="flex pt-4">
                  <SwitchField
                    name="is2FA"
                    checkedChildren={true}
                    unCheckedChildren={false}
                    label="You'll be required to verify your identity with an additional step when signing in"
                    reverse
                    onChange={(value) => {
                      setFieldValue("is2FA", value);
                      handleToggle2FA(value);
                    }}
                  />
                </div>
              </div>

              <div className="mt-5">
                <div className="w-full border-0 border-b dark:border-b-gray-800 py-4">
                  <p className="text-xl text-secondary dark:text-alpha">
                    Login & Password
                  </p>
                  <p className="text-md text-[#737373] dark:text-gray-300">
                    This is the main profile that will be visible for everyone
                  </p>
                </div>
                <div className="flex flex-col py-4 gap-16">
                  <SettingSecurityForm />
                  <div className="w-20 self-end">
                    <FormButton
                      type="submit"
                      disabled={isSubmitting || !isValid}
                      variant="filled"
                      text={isSubmitting ? <Components.Spinner /> : "Save"}
                    />
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default SecuritySettings;
